define("shared/utils/formatters/ig-comment-from-graph", ["exports", "@ember/utils", "moment", "later/models/ig-comment"], function (_exports, _utils, _moment, _igComment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"moment",0,"later/models/ig-comment"eaimeta@70e063a35619d71f
  function createIgCommentFromGraph(graphComment, socialProfile, graphMediaId) {
    let mediaId;
    if (!(0, _utils.isNone)(graphComment.media)) {
      mediaId = graphComment.media.id;
    } else if (graphMediaId) {
      mediaId = graphMediaId;
    }
    let replies = [];
    let nextRepliesUrl;
    if (!(0, _utils.isNone)(graphComment.replies)) {
      replies = graphComment.replies.data.map(reply => createIgCommentFromGraph(reply, socialProfile, graphComment.media.id));
      replies.forEach(reply => {
        reply.parentId = graphComment.id;
      });
      if (!(0, _utils.isNone)(graphComment.replies.paging)) {
        nextRepliesUrl = graphComment.replies.paging.next;
      }
    }
    return new _igComment.default({
      socialProfile,
      createdTime: (0, _moment.default)(graphComment.timestamp).unix(),
      id: graphComment.id,
      mediaId,
      text: graphComment.text,
      likeCount: graphComment.like_count,
      username: graphComment.username,
      replies,
      nextRepliesUrl
    });
  }
  var _default = _exports.default = createIgCommentFromGraph;
});